import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.CUSTOM_AVATARS],
  data () {
    return {
      logo: getPlanLogo(planTypes.CUSTOM_AVATARS),
      title: this.$t('billing.custom_avatars.title'),
      planType: planTypes.CUSTOM_AVATARS,
    }
  }
};
